
import { motion } from "motion/react"
import PricingCard from "./PricingCard"
import { pricingData } from "../data"


const PricingSection = () => {
    const container = {
      hidden: { opacity: 0 },
      show: {
        opacity: 1,

        transition: {
          staggerChildren: 0.1,
        }
      }
    }

    const item = {
      hidden: { opacity: 0, y: -100 },
      show: { opacity: 1, y: 0 }
    }

    return (
      <div className='min-h-[100vh] h-max z-10 py-20 relative'>
        <div className='container-lg px-5 '>
          <div className='space-y-10'>
            <div className="flex gap-5 items-center justify-start text-start">
            <h1 className='heading-large'>Plans And Pricing</h1>
            <h1 className='text-white bg-orange-500 px-5 py-2 rounded'>soon</h1>
            </div>
            <p className=''>Subscribe and Get Access to All our products !!</p>
            <motion.div variants={container} initial="hidden" whileInView="show" className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5   gap-5'>
          {
            pricingData?.map((pack,i)=> <PricingCard key={i} variants={item} pack={pack} />)        
          }
            </motion.div>
          </div>
        </div>
      </div>
    )
  }
export default PricingSection